const statusHelper = () => (publication, remove = false) => {
  if(!remove) {
    publication.isReady = function() { return this.status === 'ready' }
    publication.isEnqueued = function() { return this.status === 'completed' }
    publication.isDiscarded = function() { return this.status === 'discarded' }
    publication.isSent = function() { return this.status === 'sent' }

    publication.setReady = function() { this.status = 'ready' }
    publication.setEnqueued = function() { this.status = 'completed' }
    publication.setDiscarded = function() { this.status = 'discarded' }
  }
  else {
    delete publication.isReady
    delete publication.isEnqueued
    delete publication.isDiscarded
    delete publication.isSent
    delete publication.setReady
    delete publication.setEnqueued
    delete publication.setDiscarded
  }

  return publication
}

const revisionHelper = () => (publication, remove = false) => {
  if(!remove) {
    publication.isUnderRevision = function() { 
      return false
    }
    publication.isBeingEditing = function() { 
      return this.status === 'under_revision'
    }
  }
  else {
    delete publication.isUnderRevision
    delete publication.isBeingEditing
  }
  
  return publication
}

export { statusHelper, revisionHelper }